import {axios} from '../Api';

class UserService {
    getUser = async (id) => {
        const result = await axios.get(`/app/api/user/${id}`);
        return result.data;
    };

    getUsers = async () => {
        const result = await axios.get('/app/api/user');
        return result.data;
    };

    persistUser = async (data) => {
        const {id} = data;
        const url = '/app/api/user';
        const response = id ? await axios.put(url, data) : await axios.post(url, data);
        return response.data;
    };

    deleteUser = (id) => {
        return axios.delete(`/app/api/user/${id}`);
    };
}

export default new UserService();



// WEBPACK FOOTER //
// ./src/services/UserService.js